export default "__VITE_ASSET__C$6HUe_K__";